import type { ProductPageViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import ProductRegime from 'components/product/regime/ProductRegime';
import { AdvisorRecommendsTitle } from 'autogen/translation-keys/trans-website-productregime';
import { useTranslation } from 'react-i18next';
import Reviews from 'components/reviews/reviews';
import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import { CustomerReviews } from 'autogen/translation-keys/trans-website-productreview-list';
import ReviewsPreview from 'components/reviews/reviews-preview';
import ProductInformation from './components/ProductInformation';

export default function LightProductPage({ model }: { model: ProductPageViewModel }) {
    const { t } = useTranslation();
    const { productInformation, productRegime, reviews, emaLogo, productReviewHeader } = model;

    return (
        <Layout.Page>
            <Layout.Section>
                {/* Product Preview header */}
                {productReviewHeader && <ReviewsPreview model={productReviewHeader} />}

                {/* Product Information */}
                <ProductInformation productInformation={productInformation} emaLogo={emaLogo} />
            </Layout.Section>

            {/* Product Regime */}
            {productRegime && (
                <Layout.Section heading={t(AdvisorRecommendsTitle)}>
                    <ProductRegime model={productRegime} />
                </Layout.Section>
            )}

            {/* Product Reviews */}
            {reviews.reviews && (
                <Layout.Section.WithFullWidthBackground backgroundColor={ColorNordicGrey4} heading={t(CustomerReviews)}>
                    <Reviews model={reviews.reviews} />
                </Layout.Section.WithFullWidthBackground>
            )}
        </Layout.Page>
    );
}
